import { dArrowRight, Link } from '@hover/blueprint/brand';
import { chakra } from '@hover/blueprint/chakra';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import React, { useState } from 'react';

interface Props {
  to: string;
  title: string;
  isExternal?: boolean;
}

const NewsLetterLink: React.FC<Props> = ({ to, title, isExternal }) => {
  const [isOver, setIsOver] = useState(false);
  return (
    // NOTE: wtfffff, no idea why the built-in handlers aren't firing in `Link`
    <chakra.span
      onMouseEnter={() => setIsOver(true)}
      onMouseLeave={() => setIsOver(false)}
    >
      {isExternal ? (
        <Link
          colorScheme="neutral"
          as="a"
          href={to}
          mt={600}
          d="flex"
          alignItems="center"
          decorationAfter={dArrowRight}
          isOver={isOver}
        >
          {title}
        </Link>
      ) : (
        <Link
          colorScheme="neutral"
          as={AnchorLink}
          to={to}
          mt={600}
          d="flex"
          alignItems="center"
          decorationAfter={dArrowRight}
          isOver={isOver}
        >
          {title}
        </Link>
      )}
    </chakra.span>
  );
};

NewsLetterLink.defaultProps = {
  isExternal: false,
};

export default NewsLetterLink;
